import React from 'react';

const gradeColor = (g) => {
  if (g >= 4) return '#FFB300';
  return '#EF5350';
};

const ImprovementPanel = ({ improvements }) => {
  return (
    <div className="panel-card fade-in delay-300">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-1 h-6 bg-[#FFB300] rounded"></div>
        <h2 className="text-white font-bold text-base">Areas for Improvement</h2>
      </div>

      <div className="flex flex-col gap-2">
        {improvements.length === 0 ? (
          <div className="text-center py-4 text-[#546E7A] text-sm">
            No categories scoring 5 or under
          </div>
        ) : (
          improvements.map((item, index) => (
            <div key={index} className="flex items-center justify-between px-2 py-2 rounded-lg bg-[#243B55]/40">
              <span className="text-[#B0BEC5] text-sm">{item.name}</span>
              <span className="font-rajdhani font-bold text-lg" style={{ color: gradeColor(item.score) }}>
                {item.score}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ImprovementPanel;
